import { TextField, InputAdornment, useTheme, alpha } from "@mui/material";
import { useFormContext } from "../form/IForm";

const ITextBox = ({ model, label, variant = "outlined", icon, displayLabel = true, sx, ...rest }) => {
  const form = useFormContext();
  const theme = useTheme();
  const defaultSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "16px",
      background: alpha(theme.palette.background.paper ?? "#fff", 0.8),
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.main,
        borderWidth: "2px",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.main,
        borderWidth: "2px",
      },
    },
  };
  return (
    <TextField
      fullWidth
      size="small"
      name={model}
      label={displayLabel ? label : undefined}
      value={form?.values[model] ?? ""}
      onChange={form?.handleChange}
      onBlur={form?.handleBlur}
      variant={variant}
      error={form.touched[model] && Boolean(form.errors[model])}
      helperText={form.touched[model] && form.errors[model]}
      InputProps={{
        startAdornment: icon ? <InputAdornment position="start">{icon}</InputAdornment> : undefined,
      }}
      sx={{ ...defaultSx, ...sx }}
      {...rest}
    />
  );
};

export default ITextBox;
